import {AuthPolicy} from "../../backend/authorization/models/AuthPolicy";
import {graphQLServices} from "../../services/GraphQLServices";
import {
	AuthQueries,
	DELETE_POLICY,
	DELETE_POLICY_USAGE,
	PUT_POLICY,
	PUT_POLICY_USAGE
} from "../../backend/authorization/AuthQueries";
import {cloneMutationData} from "../products/Utils";
import {AuthPolicyUsage} from "../../backend/authorization/models/AuthPolicyUsage";

export async function putPolicy(stage: string | null, policy: AuthPolicy): Promise<void> {
	const response = await graphQLServices.authorizationClient.mutate<AuthQueries>({
		mutation: PUT_POLICY,
		variables: {
			policy: cloneMutationData(policy),
			stage
		}
	});
	
	const graphQlErrors = response.errors;
	if (graphQlErrors && graphQlErrors.length > 0)
		throw graphQlErrors[0];
	
	const systemErrors = response.data?.putPolicy.errors;
	if (systemErrors && systemErrors.length > 0)
		throw new Error(systemErrors[0].message);
}

export async function deletePolicy(stage: string | null, krn: string): Promise<void> {
	const response = await graphQLServices.authorizationClient.mutate<AuthQueries>({
		mutation: DELETE_POLICY,
		variables: {krn, stage}
	});
	
	const graphQlErrors = response.errors;
	if (graphQlErrors && graphQlErrors.length > 0)
		throw graphQlErrors[0];
	
	const systemErrors = response.data?.deletePolicy.errors;
	if (systemErrors && systemErrors.length > 0)
		throw new Error(systemErrors[0].message);
}

export async function putPolicyUsage(stage: string | null, policyUsage: AuthPolicyUsage): Promise<void> {
	const response = await graphQLServices.authorizationClient.mutate<AuthQueries>({
		mutation: PUT_POLICY_USAGE,
		variables: {
			policyUsage: cloneMutationData(policyUsage),
			stage
		}
	});
	
	const graphQlErrors = response.errors;
	if (graphQlErrors && graphQlErrors.length > 0)
		throw graphQlErrors[0];
	
	const systemErrors = response.data?.putPolicyUsage.errors;
	if (systemErrors && systemErrors.length > 0)
		throw new Error(systemErrors[0].message);
}

export async function deletePolicyUsage(stage: string | null, krn: string): Promise<void> {
	const response = await graphQLServices.authorizationClient.mutate({
		mutation: DELETE_POLICY_USAGE,
		variables: {krn, stage}
	});
	
	const graphQlErrors = response.errors;
	if (graphQlErrors && graphQlErrors.length > 0)
		throw graphQlErrors[0];
	
	const systemErrors = response.data?.deletePolicyUsage.errors;
	if (systemErrors && systemErrors.length > 0)
		throw new Error(systemErrors[0].message);
}
